import Loading from "components/common/loading/Loading";
import useCheckRPMSaaSAccountUser from "hooks/useCheckRPMSaaSAccountUser";
import { shouldShowPatchNav } from "pages/patchMonitoring/patchMonitoring.config";

import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router";

/* Page-level access rule for Patch Monitoring: the same `shouldShowPatchNav` rule the side
 * navigation uses, so a user without access who types the URL sees /prohibited.
 *
 * Waits for the current user and account data before deciding, so a user with access is
 * never redirected while the data is still loading.
 */
const PatchAccessGuard = ({ children }) => {
  const { currentUser } = useSelector((state) => state.auth);
  const { accounts, accountsMapper } = useSelector((state) => state.account);
  const isRPMSaaSUser = useCheckRPMSaaSAccountUser();
  const clinicName = localStorage.getItem("clinicName");

  const isLoaded =
    Object.keys(currentUser || {}).length > 0 &&
    accounts?.length > 0 &&
    Object.keys(accountsMapper || {}).length > 0;

  if (!isLoaded) return <Loading height="100%" width="100%" />;

  if (
    !shouldShowPatchNav({
      currentUser,
      accountsMapper,
      clinicName,
      isRPMSaaSUser,
    })
  ) {
    return <Navigate to="/prohibited" replace />;
  }

  return children;
};

export default PatchAccessGuard;
